import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getBreachImpactList as getBreachImpactListApi } from '../../helpers/breach_impact/api_helper';

export const getBreachImpactList = createAsyncThunk(
	'breachImpact/getBreachImpactList',
	async params => {
		try {
			const response = await getBreachImpactListApi(params);
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener impactos de incumplimiento.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);
